module.exports = __webpack_public_path__ + "img/picture_zsdsj.ebc07faa.png";